import { useLocation } from "react-router-dom";
import OnboardingStep from "../../navegation/OnboardingStep";

function OnboardCpaSteps() {
  const location = useLocation();
  
  // Define the onboarding steps
  const steps = [
    { number: 1, text: "Take the Test" },
    { number: 2, text: "License & Credentials" },
    { number: 3, text: "Connect Account" },
    { number: 4, text: "Verify Identity" },
  ];

  // Map current route to step index (0-based)
  const getCurrentStepIndex = () => {
    const pathname = location.pathname;
    if (pathname.includes("onboarding-test")) return 0;
    if (pathname.includes("provide-license")) return 1;
    if (pathname.includes("connected-account")) return 2;
    if (pathname.includes("onboarding-legal")) return 3;
    return 0; // Default to first step
  };

  const currentStep = getCurrentStepIndex();

  return (
    <div className="internal-content-header">
      <OnboardingStep
        steps={steps}
        currentStep={currentStep}
        title="Activate your account"
      />
    </div>
  );
}

export default OnboardCpaSteps;
